<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../bosques/terrenos/mapLocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
